export default __webpack_public_path__ + "static/media/placeholder_portfolio04-nl-web.a8433d4c.png";